import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { FormInput, FormDropDownListById, FormCheckbox} from "../../forms/form-components";
import { fontSizes, decimalPlaces} from "./utils";
import { dateFormats, formatDate, getThemeColors } from "../../lib/utils";
import { useTranslation } from "react-i18next";

export const CardDateWidgetSettings = props => {
    const {onFieldValueChange, formState, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const { t } = useTranslation();
    const fontColors= getThemeColors(currentTheme);

    let dataSourceTitle = formState.formValues.settings.dataSourceTitle;
    if(!dataSourceTitle)//the report is in view mode
    {
        let dataSource = formState.dataSources.find(e => e.Id == formState.formValues.dataSourceId);
        if (!dataSource.IsImplicit)
            dataSourceTitle = dataSource.Title;
        else
            dataSourceTitle = formState.formValues.settings.schema[0].Title;
    }

    return (
        <Fragment>
            <div className="card-date-settings">
                <div className="widget-settings-form-group" style={{marginBottom: 0}}>
                    <div className="header">
                          {t("extras.widget")}
                    </div>
                    <div className="content">
                        {
                            formState.mode == 2 && 
                            <div className="row" style={{alignItems: "center", justifyContent: "flex-start"}}>
                                <div style={{fontWeight: 600}}>{t("extras.datasource")}</div>
                                <div style={{marginLeft: 16}}>
                                    {dataSourceTitle}
                                </div>
                            </div>
                        }
                        <div className="row" style={{alignItems: "center", justifyContent: "flex-start"}}>
                            <div style={{width:125}}>
                                <Field 
                                    id={"settings.reorderable"}
                                    name={"settings.reorderable"}
                                    label={t("extras.draggable")}
                                    component={FormCheckbox}
                                    onChange={e => onFieldValueChange({id: "reorderable", value: e.value})}
                                    />
                            </div>
                            <div style={{width:125, marginLeft: 24}}>
                                <Field 
                                    id={"settings.resizable"}
                                    name={"settings.resizable"}
                                    label={t("extras.resizable")}
                                    component={FormCheckbox}                                  
                                    onChange={e => onFieldValueChange({id: "resizable", value: e.value})}
                                    />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="widget-settings-form-group" style={{marginBottom: 0}}>
                    <div className="header">
                         {t("extras.title")}
                    </div>
                    <div className="content">                        
                        <div className="row">
                            <Field
                                id={"settings.title"}
                                name={"settings.title"}
                                component={FormInput}
                                maxLength={255}
                                style={{width:"100%"}}
                                onChange={e => onFieldValueChange({id: "title", value: e.target.value})}
                                />
                        </div>
                        <div className="row">
                            <div style={{width:125}}>
                                <Field
                                    id={"settings.titleFontColor"}
                                    name={"settings.titleFontColor"}
                                    label={t("extras.color*")}
                                    component={FormDropDownListById}
                                    data={fontColors} dataItemKey="id" textField="title"  
                                    onChange={e => onFieldValueChange({id: "titleFontColor", value: e.value})}
                                    />
                            </div>
                            <div style={{width:125, marginLeft: 24}}>
                                <Field
                                    id={"settings.titleFontSize"}
                                    name={"settings.titleFontSize"}
                                    label={t("extras.size")}
                                    component={FormDropDownListById}
                                    data={fontSizes} dataItemKey="id" textField="title"  
                                    style={{marginTop:2}}
                                    onChange={e => onFieldValueChange({id: "titleFontSize", value: e.value})}
                                    />
                            </div>                            
                            <div style={{display: "flex", flex: 1}}>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsBold"}
                                        name={"settings.titleFontIsBold"}
                                        label={t("extras.bold")}
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsBold", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsUnderline"}
                                        name={"settings.titleFontIsUnderline"}
                                        label={t("extras.underline")} 
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsUnderline", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.titleFontIsItalic"}
                                        name={"settings.titleFontIsItalic"}
                                        label={t("extras.italic")}
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "titleFontIsItalic", value: e.value})}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="widget-settings-form-group" style={{marginBottom: 0}}>
                    <div className="header">
                        {t("extras.value")} 
                    </div>
                    <div className="content">
                        <div className="row">
                            <div style={{width:125}}>
                                <Field
                                    id={"settings.fontColor"}
                                    name={"settings.fontColor"}
                                    label={t("extras.color")}
                                    component={FormDropDownListById}
                                    data={fontColors} dataItemKey="id" textField="title"  
                                    onChange={e => onFieldValueChange({id: "fontColor", value: e.value})}
                                    />
                            </div>
                            <div style={{width:125, marginLeft: 24}}>
                                <Field
                                    id={"settings.fontSize"}
                                    name={"settings.fontSize"}
                                    label={t("extras.size")} 
                                    component={FormDropDownListById}
                                    data={fontSizes} dataItemKey="id" textField="title" 
                                    onChange={e => onFieldValueChange({id: "fontSize", value: e.value})}
                                    />
                            </div>                            
                            <div style={{display: "flex", flex: 1}}>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.fontIsBold"}
                                        name={"settings.fontIsBold"}
                                        label={t("extras.bold")}
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "fontIsBold", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.fontIsUnderline"}
                                        name={"settings.fontIsUnderline"}
                                        label={t("extras.underline")}
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "fontIsUnderline", value: e.value})}
                                        />
                                </div>
                                <div style={{marginLeft: 24}}>
                                    <Field 
                                        id={"settings.fontIsItalic"}
                                        name={"settings.fontIsItalic"}
                                        label={t("extras.italic")} 
                                        component={FormCheckbox}
                                        onChange={e => onFieldValueChange({id: "fontIsItalic", value: e.value})}
                                        />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: 0}}>
                            <div style={{flex:1 }}>
                                <Field
                                    id={"settings.dateFormat"}
                                    name={"settings.dateFormat"}
                                    label={t("extras.dateFormat")} 
                                    component={FormDropDownListById}
                                    data={dateFormats} dataItemKey="id" textField="title"  
                                    onChange={e => onFieldValueChange({id: "dateFormat", value: e.value})}
                                    />
                            </div>
                        </div>
                    </div>
                </div>                           
            </div>
            <style>
                {
                    `
                        .widget-settings-form-group:nth-child(2) .k-form-field:first-of-type
                        {
                            width: 100%;
                        }
                       
                        .card-date-settings
                        {
                            display: flex;
                            flex-direction: column;
                            align-items: stretch;
                        }                      
                    `
                }
            </style>
        </Fragment>
    );
};
